
import { jsxutils } from 'apprise-frontend-core/utils/common'
import { Component } from 'apprise-ui/component/component'
import { Styled } from 'apprise-ui/component/model'
import * as React from 'react'
import "./styles.scss"
import { utils } from 'apprise-core/utils'



export type Props = Styled & React.PropsWithChildren

export const Header = (props: Partial<Props>) => {

    const { elementsIn, isElementOf} = jsxutils()       
    
    const children = elementsIn(props.children)

    const lefties = children.filter(isElementOf(Header.Left)).map((r,i)=><div key={i} className='header-left-part'>{r}</div>)
    const righties = children.filter(isElementOf(Header.Right)).map((r,i)=><div key={i} className='header-right-part'>{r}</div>)

    const other = children.flatMap(utils().arrayOf).filter(e=>!isElementOf(Header.Left)(e) && !isElementOf(Header.Right)(e))

    return <Component name='header' {...props}>

        {lefties.length > 0 &&

            <div className='header-part header-left'>
                {lefties}
            </div>
        }

        <div className='header-part header-other'>
            {other}
        </div>

        {righties.length > 0 &&
            <div className='header-part header-right'>
                {righties}
            </div>
        }

    </Component>

}

// child naming functions
Header.Left = function Left(props: React.PropsWithChildren) { return <>{props.children}</> }
Header.Right = function Right(props: React.PropsWithChildren) { return <>{props.children}</> }



